import { Reducer } from "redux"
import { IEditMeetingOrderData } from "shared/Types/MeetingPlanning/deliveryForm"
import { MeetingPlanningEditOrderAction, MeetingPlanningEditOrderActionTypes } from "./MeetingPlanningEditOrderActions"


const meetingPlanningEditOrderState: IEditMeetingOrderData | null = null

const meetingPlanningEditOrderReducer: Reducer<IEditMeetingOrderData | null> = (
    state: IEditMeetingOrderData | null = meetingPlanningEditOrderState,
    action: MeetingPlanningEditOrderAction
): IEditMeetingOrderData | null => {
    switch (action.type) {
        case MeetingPlanningEditOrderActionTypes.EDIT_ORDER:
            return { ...action.payload }

        default:
            return state
    }
}

export default meetingPlanningEditOrderReducer
